/** Direct results and retained cleanup receipts share the page lifecycle, never a blank fallback. */
import * as z from 'zod'
import {
  directStudyResultsSchema,
  studyAuthoringStatusSchema,
  studyAuthoringDeletionReceiptSchema,
} from '@testfeed/shopify-contracts'
import { definePage } from '../page-declaration'
const source = z.union([
  z.strictObject({
    selectionKey: z.string(),
    results: directStudyResultsSchema,
    authoring: studyAuthoringStatusSchema,
    deletion: z.null(),
  }),
  z.strictObject({
    selectionKey: z.string(),
    results: z.null(),
    authoring: z.null(),
    deletion: studyAuthoringDeletionReceiptSchema,
  }),
])
export const page = definePage({
  name: 'direct-study-results',
  sources: { result: { required: true, check: source } },
  actions: {
    'create-next-test': {
      saves: false,
      interaction: { textEditing: 'block' },
      feedback: { failure: 'The draft could not be created. Try again.' },
    },
    'delete-setup': {
      saves: false,
      interaction: { textEditing: 'block' },
      feedback: { failure: 'The test could not be deleted. Try again.' },
    },
  },
})
